import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogOut, User, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/shared";
import { useAuth } from "@/context/AuthContext";

export default function Settings() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div data-testid="employer-settings">
      <PageHeader title={t("set.title")} subtitle={t("set.sub")} />
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="card-soft p-6">
          <div className="mb-4 flex items-center gap-2 font-heading font-bold text-navy"><User className="h-4 w-4 text-cyan-dark" /> {t("set.profile")}</div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between border-b border-slate-50 py-2"><span className="text-slate-400">{t("set.name")}</span><span className="font-medium text-navy">{user?.first_name} {user?.last_name}</span></div>
            <div className="flex justify-between border-b border-slate-50 py-2"><span className="text-slate-400">{t("set.email")}</span><span className="font-medium text-navy">{user?.email}</span></div>
            <div className="flex justify-between py-2"><span className="text-slate-400">{t("set.role")}</span><span className="font-medium text-navy">{user?.role?.replace("_", " ")}</span></div>
          </div>
        </div>
        <div className="card-soft p-6">
          <div className="mb-4 flex items-center gap-2 font-heading font-bold text-navy"><Shield className="h-4 w-4 text-cyan-dark" /> {t("set.session")}</div>
          <p className="mb-4 text-sm text-slate-500">{t("set.sessionDesc")}</p>
          <Button variant="outline" className="rounded-full text-red-600" onClick={async () => { await logout(); nav("/login"); }} data-testid="settings-logout"><LogOut className="mr-2 h-4 w-4" /> {t("set.logout")}</Button>
        </div>
      </div>
    </div>
  );
}
